import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';
import { PaymentService } from './payment.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentGuard implements CanActivate {
  constructor(private router: Router, private userInfoService: UserInfoService, private paymentService: PaymentService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const productKey = route.params['name'];
    const lang = route.params['lang'];
    const isPurchased = await this.paymentService.checkIsProductPurchased(productKey);
    if (isPurchased || this.userInfoService.getUserId() == "a068924c-43e2-4293-927b-c0c7a1ad400f") {
      return true;
    }
    this.router.navigate(['/' + lang + '/payment'], { state: { productKey: productKey } });
    return false;
  }  
}
